import styled from 'styled-components';

export const DrawerContents = styled.div`
  padding: 60px 0 0 0;
  height: 100%;
`;
DrawerContents.displayName = 'S.DrawerContents';
